import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { ForestryLink } from '../../../../utilities'

import * as styles from './mainLinks.module.scss'

export default ({ }) => {
  
  const { site: { siteMetadata: { footer: { mainLinks } } } } = useStaticQuery(graphql`
  {
    site {
      siteMetadata {
        footer {
          mainLinks {
            article
            label
            page
            link_type
            url
            hide
          }
        }
      }
    }
  }`)

  return (
    <div className={styles.container}>
      <div className={styles.links}>
        {mainLinks.filter(l => !l.hide).map(link => (
          <div key={link.label}>
            {(link.link_type === "Article" || link.link_type === "Page") ? (
              <ForestryLink key={link.page} className={styles.link} activeClassName={styles.active} to={link.page || link.article}>
                <p>{link.label}</p>
              </ForestryLink>
            ) : <a className={styles.link} href={link.url}><p>{link.label}</p></a>}
          </div>
        ))}
      </div>
    </div>
  )
}